// extracted by mini-css-extract-plugin
export var dropdown = "_uo-0";
export var imageWrapper = "_uo-3";
export var itemNameContainer = "_uo-1";
export var productImage = "_uo-2";
export var spinnerWrapper = "_uo-4";